import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from '../state/action-sources';

/**
 * What became of a refund or a hold release AFTER the request that started it
 * had already answered.
 *
 * Requirement: a BlueSage refund answers the browser as soon as its leg exists
 * and settles in the background — a terminal can take minutes, and the
 * production ingress cuts a request at 60 s. The outcome therefore arrives on
 * the LEG, some time later and possibly after the dialog has been closed, so it
 * is announced from the job rather than from a dialog.
 */
export const BlueSageRefundLegActions = createActionGroup({
    source: ActionSource.BLUESAGE_REFUND_LEG,
    events: {
        'Refund Confirmed': emptyProps(),
        'Refund Not Confirmed': props<{ error: Error }>(),
        'Release Confirmed': emptyProps(),
        'Release Not Confirmed': props<{ error: Error }>(),

        // Nothing was heard within the window. Not an outcome — the leg is still
        // `pending` — so it carries no toast; it stops a dialog spinning for ever.
        'Outcome Window Closed': props<{ transactionId: string }>(),
    },
});
